import { callApi } from "@/api/api-core";

export const loginCustomer = function(
    countryCode,
    phoneNumber,
    password,
    ownerHandlesFailure
) {
    const requestData = {
        countryCode,
        phoneNumber,
        password
    };

    return callApi(
            "POST",
            "v1/user/login/phonenumber",
            requestData,
            ownerHandlesFailure
        );
};

export const passwordRecovery = function(
    countryCode,
    phoneNumber,
    ownerHandlesFailure
) {
    const requestData = {
        countryCode,
        phoneNumber,
    };

    return callApi(
            "POST",
            "v1/user/recovery/phonenumber",
            requestData,
            ownerHandlesFailure
        );
};
